import React, { FC } from 'react'
import { Trans } from '@lingui/macro'
import {
  Box,
  ButtonDanger,
  ButtonPrimary,
  Flex
} from 'front-end/src/components'
import { brandColors } from '../../../../shared/basicPalette'
import { Heading } from '@chakra-ui/react'
import { useGoogleAuth } from '../../app/hooks/useGoogleAuth'

export const UserAuthentication: FC = () => {
  const { isAuthenticated, authenticate, revoke } = useGoogleAuth()

  return (
    <div className="User__authentication">
      <h3>
        <Trans>Authentication</Trans>
      </h3>
      <p className="text-description">
        <Trans>Authenticated accounts and granted access permissions</Trans>
      </p>
      <Box p="12px" mt="16px">
        <Flex
          align="center"
          justify="space-between"
          p="8px"
          pl="16px"
          backgroundColor={brandColors.grey.lightest}
        >
          <Heading size="md">
            <Trans>Google calendar</Trans>
          </Heading>
          {isAuthenticated ? (
            <ButtonDanger onClick={async () => revoke()}>
              <Trans>Revoke</Trans>
            </ButtonDanger>
          ) : (
            <ButtonPrimary onClick={async () => authenticate()}>
              <Trans>Authenticate</Trans>
            </ButtonPrimary>
          )}
        </Flex>
      </Box>
    </div>
  )
}
